import { ReactNode, Ref } from "react";

import styled from 'styled-components'

export const Wrapper = styled.div<{ $flexDirection: 'column' | 'row', $ref?: Ref<OrNull<HTMLDivElement>> }>`
  display: flex;
  flex-direction: ${props => props.$flexDirection};
`
type OrNull<T> = T | null

export const Flex = ({
  flexDirection, 
  ref,
  children
}:{
  flexDirection: 'column' | 'row'
  ref?: Ref<OrNull<HTMLDivElement>>
  children: ReactNode;
}) => {

  return <Wrapper $flexDirection={flexDirection}>
    {children}
  </Wrapper>
}